import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import piHomeCard from "../pi-home-card/pi-home-card.vue";
import { getHomeStatAssets } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import { piOhGetProgress } from "@/utils/object.helper";
let PiHomeAccets = class PiHomeAccets extends Vue {
    constructor() {
        super(...arguments);
        this.assetsList = [
            {
                name: i18n.t("home.staCount"),
                value: 0,
                icon: require("@/assets/home/accets-site.png"),
                iconBg: require("@/assets/home/accets-site-bg.png"),
                key: "staCount",
            },
            {
                name: i18n.t("home.pileCount"),
                value: 0,
                key: "pileCount",
                icon: require("@/assets/home/accets-pile.png"),
                flex: true,
                dc: "0",
                dcProgress: "50%",
                ac: "0",
                acProgress: "50%",
                dcKey: "dcPileCount",
                acKey: "acPileCount",
            },
            {
                name: i18n.t("home.gunCount"),
                value: 0,
                key: "gunCount",
                icon: require("@/assets/home/accets-gun.png"),
                flex: true,
                dc: "0",
                dcProgress: "50%",
                ac: "0",
                acProgress: "50%",
                dcKey: "dcGunCount",
                acKey: "acGunCount",
            },
            {
                name: i18n.t("home.totalPower"),
                value: 0,
                key: "totalPower",
                icon: require("@/assets/home/accets-power.png"),
                flex: true,
                dc: "0",
                dcProgress: "50%",
                ac: "0",
                acProgress: "50%",
                dcKey: "dcPower",
                acKey: "acPower",
            },
        ];
        this.statAssets = {};
    }
    /**
     * 获取资产数据
     */
    async getHomeStatAssets() {
        const ret = await getHomeStatAssets({});
        if (ret.status === this.$config.apiStatus) {
            let data = ret.data[0] || {};
            this.saveData(data);
        }
    }
    /**
     * 参数赋值
     */
    saveData(data) {
        this.assetsList.map((item) => {
            item.value = data[item.key];
            if (item.dcKey) {
                item.dc = data[item.dcKey];
                item.ac = data[item.acKey];
                item.acProgress = piOhGetProgress(item.ac, item.ac + item.dc);
                item.dcProgress = piOhGetProgress(item.dc, item.ac + item.dc);
            }
        });
    }
    mounted() {
        this.getHomeStatAssets();
    }
};
PiHomeAccets = __decorate([
    Component({
        components: {
            "pi-home-card": piHomeCard,
        },
    })
], PiHomeAccets);
export default PiHomeAccets;
